import { ReactNode } from "react";
import { Badge } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { TextCell } from "../TextCell";

const MAX_VISIBLE_BADGES = 3;

export interface BadgeListCellProps {
  items: { key: string; label: ReactNode }[];
  emptyLabel: string;
}

export const BadgeListCell = ({ items, emptyLabel }: BadgeListCellProps) => {
  const { t } = useTranslation();

  if (items.length === 0) return <TextCell className="text-muted-foreground">{emptyLabel}</TextCell>;

  const overflowCount = items.length - MAX_VISIBLE_BADGES;

  return (
    <div className="flex flex-nowrap gap-1 overflow-x-auto scrollbar-none mr-2">
      {items.slice(0, MAX_VISIBLE_BADGES).map(({ key, label }) => (
        <Badge key={key} variant="secondary" className="text-xs whitespace-nowrap">
          {label}
        </Badge>
      ))}
      {overflowCount > 0 && (
        <Badge variant="outline" className="text-xs whitespace-nowrap">
          {t("+ {{amount}} more", { amount: overflowCount })}
        </Badge>
      )}
    </div>
  );
};
